module.exports = __webpack_public_path__ + "static/media/blur.62565796.svg";